import React, { useState } from 'react';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import DateTimePickerComponent from '@cp/components/DateTimePicker/DateTimePickerComponent';
import { DATE_TIME_TYPE } from '@cp/components/DateTimePicker/constants';
import styles from './RecentActivityChangePopover.module.scss';
import dayjs from 'dayjs';

interface RecentActivityChangePopoverProps {
  initialDate?: Date | null;
  onCancel: () => void;
  onSave: (date: Date) => void;
  isLoading?: boolean;
}

const RecentActivityChangePopover: React.FC<RecentActivityChangePopoverProps> = ({
  initialDate,
  onCancel,
  onSave,
  isLoading = false
}) => {
  const [selectedDate, setSelectedDate] = useState<string>(
    initialDate ? dayjs(initialDate).format('YYYY-MM-DD') : ''
  );

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedDate(e.target.value);
  };

  const handleSave = () => {
    if (selectedDate) {
      onSave(new Date(selectedDate));
    }
  };

  const handleContainerClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div className={styles.popoverContainer} onClick={handleContainerClick}>
      <Typography variant="h5" color="var(--grayscale-1)">
        Recent activity
      </Typography>
      <div className={styles.datePickerContainer}>
        <DateTimePickerComponent
          type={DATE_TIME_TYPE.DATE}
          value={selectedDate}
          onChange={handleDateChange}
          className={styles.datePickerWrapper}
          containerClasses={styles.datePickerInnerContainer}
          min={initialDate ? dayjs(initialDate).format('YYYY-MM-DD') : undefined}
        />
      </div>
      <div className={styles.buttonContainer}>
        <Button
          variant="secondary"
          size="small"
          onClick={onCancel}
          className={styles.cancelButton}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          size="small"
          onClick={handleSave}
          disabled={!selectedDate || isLoading}
          className={styles.saveButton}
        >
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </div>
    </div>
  );
};

export default RecentActivityChangePopover;
